import React from 'react';
import { useBooking } from '../context/BookingContext';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
export const BookingForm = () => {
  const {
    booking,
    setBooking,
    nextStep,
    prevStep
  } = useBooking();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setBooking(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    nextStep();
  };
  const isFormValid = () => {
    return booking.customerName.trim() !== '' && booking.customerEmail.trim() !== '' && booking.customerPhone.trim() !== '';
  };
  return <div data-id="element-39">
      <h3 className="text-xl font-medium text-amber-400 mb-2" data-id="element-40">
        Your Information
      </h3>
      <p className="text-blue-100 mb-6" data-id="element-41">
        Please provide your contact details to complete your booking
      </p>
      <form onSubmit={handleSubmit} className="space-y-4 mb-8" data-id="element-42">
        <div data-id="element-43">
          <label htmlFor="customerName" className="block text-sm font-medium text-amber-200 mb-1" data-id="element-44">
            Full Name
          </label>
          <input type="text" id="customerName" name="customerName" value={booking.customerName} onChange={handleChange} className="w-full px-3 py-2 bg-blue-950 border border-blue-700 rounded-md text-blue-100 focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500" required data-id="element-45" />
        </div>
        <div data-id="element-46">
          <label htmlFor="customerEmail" className="block text-sm font-medium text-amber-200 mb-1" data-id="element-47">
            Email Address
          </label>
          <input type="email" id="customerEmail" name="customerEmail" value={booking.customerEmail} onChange={handleChange} className="w-full px-3 py-2 bg-blue-950 border border-blue-700 rounded-md text-blue-100 focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500" required data-id="element-48" />
        </div>
        <div data-id="element-49">
          <label htmlFor="customerPhone" className="block text-sm font-medium text-amber-200 mb-1" data-id="element-50">
            Phone Number
          </label>
          <input type="tel" id="customerPhone" name="customerPhone" value={booking.customerPhone} onChange={handleChange} className="w-full px-3 py-2 bg-blue-950 border border-blue-700 rounded-md text-blue-100 focus:outline-none focus:ring-2 focus:ring-amber-500/30 focus:border-amber-500" required data-id="element-51" />
        </div>
        <div className="pt-4" data-id="element-52">
          <h4 className="text-lg font-medium text-amber-300 mb-3" data-id="element-53">
            Booking Summary
          </h4>
          <div className="bg-blue-950 rounded-md p-4 border border-blue-800" data-id="element-54">
            <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-55">
              <div className="text-blue-300" data-id="element-56">Location:</div>
              <div className="font-medium text-amber-200" data-id="element-57">
                {booking.branch?.name}
              </div>
              <div className="text-blue-300" data-id="element-58">Service:</div>
              <div className="font-medium text-amber-200" data-id="element-59">
                {booking.service?.name}
              </div>
              <div className="text-blue-300" data-id="element-60">Stylist:</div>
              <div className="font-medium text-amber-200" data-id="element-61">
                {booking.stylist?.name}
              </div>
              <div className="text-blue-300" data-id="element-62">Date:</div>
              <div className="font-medium text-amber-200" data-id="element-63">
                {booking.date?.toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
              })}
              </div>
              <div className="text-blue-300" data-id="element-64">Time:</div>
              <div className="font-medium text-amber-200" data-id="element-65">{booking.time}</div>
              <div className="text-blue-300" data-id="element-66">Duration:</div>
              <div className="font-medium text-amber-200" data-id="element-67">
                {booking.service?.duration} minutes
              </div>
              <div className="text-blue-300" data-id="element-68">Price:</div>
              <div className="font-medium text-amber-400" data-id="element-69">
                ${booking.service?.price}
              </div>
            </div>
          </div>
        </div>
      </form>
      <div className="flex justify-between" data-id="element-70">
        <button onClick={prevStep} className="flex items-center gap-1 px-4 py-2 border border-blue-700 rounded-md text-blue-100 hover:bg-blue-800 transition-colors" data-id="element-71">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-72" /> Back
        </button>
        <button onClick={handleSubmit} className={`flex items-center gap-1 px-4 py-2 rounded-md transition-colors ${isFormValid() ? 'bg-amber-500 text-blue-950 hover:bg-amber-400' : 'bg-blue-800 text-blue-500 cursor-not-allowed'}`} disabled={!isFormValid()} data-id="element-73">
          Complete Booking <ArrowRightIcon className="w-4 h-4" data-id="element-74" />
        </button>
      </div>
    </div>;
};